import { render } from "./AmazonSellerCentralPage.vue?vue&type=template&id=cfe0e54c"
import script from "./AmazonSellerCentralPage.vue?vue&type=script&lang=js"
export * from "./AmazonSellerCentralPage.vue?vue&type=script&lang=js"

import "./AmazonSellerCentralPage.vue?vue&type=style&index=0&id=cfe0e54c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__